import { NgModule } from '@angular/core'
import { CommonModule } from '@angular/common'
import { MiniCartDetailsComponent } from './mini-cart-details/mini-cart-details.component'
import { MediaModule } from '@spartacus/storefront'
import { ConfigModule, I18nModule } from '@spartacus/core'
import { environment } from '../../../../../environments/environment'

@NgModule({
  // declarations: [MiniCartDetailsComponent],
  imports: [
    CommonModule,
    MediaModule,
    I18nModule,
    ConfigModule.withConfig({
      i18n: {
        backend: {
          loadPath:
            environment.deployPath + '/assets/i18n-assets/{{lng}}/{{ns}}.json',
        },
        chunks: {
          common: ['miniCartDetail'],
        },
      },
    }),
  ],
})
export class MiniCartDetailModule {}
